export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#011C43',
      light: '#588ab8',
      dark: '#000123',
    },
    secondary: {
      main: '#EB651E',
    },
  },
  typography: {
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,   // Increased from 500
    fontWeightBold: 700,
    fontSize: 12, // Base font size (default is 14)
    h1: { fontSize: '1.8rem' },
    h2: { fontSize: '1.6rem' },
    h3: { fontSize: '1.4rem' },
    h4: { fontSize: '1.2rem' },
    h5: { fontSize: '1.1rem' },
    h6: { fontSize: '1rem' },
    subtitle1: { fontSize: '0.875rem' },
    subtitle2: { fontSize: '0.8125rem' },
    body1: { fontSize: '0.875rem' },
    body2: { fontSize: '0.8125rem' },
    button: { fontSize: '0.8125rem' },
    caption: { fontSize: '0.75rem' },
    overline: { fontSize: '0.75rem' },
  },
};